import React from 'react'
import { Link } from "react-router-dom";


const Paediatrics = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>बाल चिकित्सा</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                <li className="breadcrumb-item">बाल चिकित्सा</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>
      <section className="content-inner" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_05.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_06.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Paediatrics_04.webp" alt="/" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/Paediatrics.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>बाल चिकित्सा</h2>
                <p>मेडिसिन का वह एरिया जिसे पीडियाट्रिक्स कहते हैं, वह नए जन्मे बच्चों से लेकर टीनएजर्स तक, सभी तरह की हेल्थ प्रॉब्लम्स की रोकथाम, डायग्नोसिस, ट्रीटमेंट और मैनेजमेंट के लिए डेडिकेटेड है। पीडियाट्रिक पेशेंट्स की उम्र आमतौर पर 0-16 साल के बीच होती है, हालांकि यह अलग-अलग हो सकती है।</p>
                <p>एक बच्चे को जिस भी मेडिकल ट्रीटमेंट की ज़रूरत हो सकती है, वह पीडियाट्रिक्स का सब्जेक्ट है। सबसे बढ़कर, यह बच्चे के जनरल डेवलपमेंट और ग्रोथ पर फोकस करता है। उनकी मेडिकल ज़रूरतें भी काफी बदल जाती हैं, भले ही थोड़े समय में, क्योंकि उनका शरीर छोटा होता है और समय के साथ ग्रोथ के कई स्टेज से गुज़रता है। यह बात कि पीडियाट्रिक्स में माता-पिता या गार्जियन को सही चाइल्डकेयर के बारे में सलाह देना, इंस्ट्रक्शन देना और कभी-कभी डांटना भी शामिल है, एक और खास बात है।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ सभी बच्चों की इमरजेंसी के लिए वेल बेबी क्लिनिक</li>
                  <li>  ✅ इम्यूनाइजेशन</li>
                  <li>  ✅ रेडिएंट वार्मर</li>
                  <li>  ✅ नवजात शिशु की देखभाल</li>
                  <li>  ✅ फोटोथेरेपी</li>
                  <li>  ✅ जीवनशैली और स्वच्छता संबंधी मार्गदर्शन</li>
                </ul>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>बच्चों के लिए मुख्य स्वास्थ्य सेवाएँ</h3>
                <b style={{ color: "black" }}>1. नवजात और शिशु की देखभाल</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ जन्म के समय जांच और स्क्रीनिंग</li>
                  <li>  ✅ वज़न, खान-पान और विकास की निगरानी</li>
                  <li>  ✅ समय से पहले जन्मे शिशुओं के लिए नवजात देखभाल</li>
                </ul>
                <b style={{ color: "black" }}>2. विकास और वृद्धि की निगरानी</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ कद, वज़न और विकास के पड़ावों पर नज़र रखना</li>
                  <li>  ✅ बोलने की क्षमता, शारीरिक कौशल और व्यवहार का आकलन</li>
                  <li>  ✅ विकास में देरी का शीघ्र पता लगाना</li>
                </ul>
                <b style={{ color: "black" }}>3. टीकाकरण और प्रतिरक्षण</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ बच्चों के नियमित टीके</li>
                  <li>  ✅ संक्रमणों और बीमारियों से सुरक्षा</li>
                  <li>  ✅ प्रतिरक्षण कार्यक्रम संबंधी मार्गदर्शन</li>
                </ul>
                <b style={{ color: "black" }}>4. निदान और उपचार</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ बुखार, संक्रमण, खांसी, ज़ुकाम</li>
                  <li>  ✅ एलर्जी और अस्थमा</li>
                  <li>  ✅ पाचन और पोषण संबंधी समस्याएं</li>
                  <li>  ✅ त्वचा संबंधी समस्याएं और छोटी-मोटी चोटें</li>
                </ul>
                <b style={{ color: "black" }}>5. बच्चों का पोषण और स्वास्थ्य संबंधी मार्गदर्शन</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ स्वस्थ विकास के लिए आहार योजना</li>
                  <li>  ✅ स्तनपान और आहार संबंधी सलाह</li>
                  <li>  ✅ मोटापा और पोषक तत्वों की कमी का प्रबंधन</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/paediatrics">बाल चिकित्सा</Link></li>
                    <li><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                    <li ><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                    <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>



    </>
  )
}

export default Paediatrics